import { ObjectOps } from '../lift';
/**
 * Returns whether this object contains no keys.
 */
export function isEmpty() {
    return Object.keys(this.value()).length === 0;
}
ObjectOps.prototype.isEmpty = isEmpty;
